// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_footer-container__Ocrdn {
  background-color: #4a90e2;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 20px; /* slight vertical breathing room */
  position: fixed;
  bottom: 0;
  width: 100%;
  min-height: 30px; /* allows 1-line text without cramping */
  z-index: 1000;
}

.Footer_footer-links__0pj9X {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1000px;
  white-space: nowrap; /* prevents text wrapping */
  overflow: hidden; /* ensures no overflow leaks */
}

.Footer_left-links__Dyj-N,
.Footer_right-link__FkQsR {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}

.Footer_left-links__Dyj-N a {
  color: #fff;
  text-decoration: none;
  font-size: 14px;
  margin-right: 16px;
  white-space: nowrap;
}

.Footer_right-link__FkQsR {
  color: #fff;
  font-size: 14px;
  white-space: nowrap;
}

/* Optional mobile tweak: collapse to single line, scrollable if needed */
@media (max-width: 768px) {
  .Footer_footer-links__0pj9X {
    flex-direction: row;
    overflow-x: auto;
    padding-bottom: 2px;
    gap: 12px;
  }

  .Footer_left-links__Dyj-N {
    flex: 1 1;
    overflow-x: auto;
    gap: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB,EAAE,mCAAmC;EACtD,eAAe;EACf,SAAS;EACT,WAAW;EACX,gBAAgB,EAAE,wCAAwC;EAC1D,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,mBAAmB,EAAE,2BAA2B;EAChD,gBAAgB,EAAE,8BAA8B;AAClD;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA,yEAAyE;AACzE;EACE;IACE,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,SAAS;EACX;AACF","sourcesContent":[".footer-container {\n  background-color: #4a90e2;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 4px 20px; /* slight vertical breathing room */\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  min-height: 30px; /* allows 1-line text without cramping */\n  z-index: 1000;\n}\n\n.footer-links {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  max-width: 1000px;\n  white-space: nowrap; /* prevents text wrapping */\n  overflow: hidden; /* ensures no overflow leaks */\n}\n\n.left-links,\n.right-link {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n}\n\n.left-links a {\n  color: #fff;\n  text-decoration: none;\n  font-size: 14px;\n  margin-right: 16px;\n  white-space: nowrap;\n}\n\n.right-link {\n  color: #fff;\n  font-size: 14px;\n  white-space: nowrap;\n}\n\n/* Optional mobile tweak: collapse to single line, scrollable if needed */\n@media (max-width: 768px) {\n  .footer-links {\n    flex-direction: row;\n    overflow-x: auto;\n    padding-bottom: 2px;\n    gap: 12px;\n  }\n\n  .left-links {\n    flex: 1;\n    overflow-x: auto;\n    gap: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer-container": `Footer_footer-container__Ocrdn`,
	"footer-links": `Footer_footer-links__0pj9X`,
	"left-links": `Footer_left-links__Dyj-N`,
	"right-link": `Footer_right-link__FkQsR`
};
export default ___CSS_LOADER_EXPORT___;
